<template>
    <div id="goodsOrder">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title" style="font-size: 17px; font-weight: 700; letter-spacing:1px;">{{langText.fillInTheOrder}}</div>
        </nav-bar>
        <div style="height: 59px"></div>

<!--        展示地址-->
        <div class="address-show" @click="goAddressEdit" style="width: 93%; border-radius: 10px; margin: auto;"  v-if="address!=null">
            <span>
                <div class="address-show-left">
                    <p class="seventh-title">
                    <span>{{address.name}}</span>&nbsp&nbsp&nbsp
                    <span>{{address.phoneNumber}}</span>
                    </p>
                    <p class="nine-title">
                    <span>{{langText.address}}:</span>&nbsp&nbsp&nbsp
                    <span>{{address.province}}{{address.city}}{{address.region}}{{address.detailAddress}}</span>
                    </p>
                </div>

                <div class="address-show-right">
                  <van-icon name="arrow" size="40" style="float: right; margin-top: 26px; padding-right: 5px"/>
                </div>
                <img style="border-radius: 10px;" :src="require('@/assets/image/icon/address_line.png')" alt="" width="100%" height="12px">
                <div style="width: 100%; height: 10px; background: white; border-radius: 10px;"></div>
            </span>
        </div>
<!--        点击设置地址-->
        <div class="address-show" @click="addressEdit" style="width: 93%; border-radius: 10px; margin: auto;" v-else-if="address==null">
            <span>
                <div class="address-show-left">
                    <p class="seventh-title">&nbsp&nbsp&nbsp
                        <span>&nbsp;</span>
                        <br/>
                        <span>{{langText.ClickSetAddress}}</span>
                    </p>
                </div>

                <div class="address-show-right">
                  <van-icon name="arrow" size="40" style="float: right; margin-top: 26px; padding-right: 5px"/>
                </div>
                <img :src="require('@/assets/image/icon/address_line.png')" alt="" width="100%" height="12px">
            </span>
        </div>
<!--        付款商品主体-->
        <div class="goods-order-info-list"  >
            <div class="goods-order-info-name" style="border-top-right-radius: 10px; border-top-left-radius: 10px;">
                <span class="eight-title" style="margin-left: 16px; font-weight: 700; font-size: 15px">{{langText.goodsInformation}}</span>
            </div>
            <div class="order-list-goods">
                <van-card
                        :num="item.quantity"
                        :price="item.price - item.reduceAmount"
                        :origin-price="item.price"
                        :desc="getProductDesc(item.productAttr)"
                        :title="item.productName"
                        :thumb="item.productPic"
                        v-for="(item, index) of order.cartPromotionItemVOList">
                    <template #footer>
                        <div class="activity-info">{{item.promotionMessage}}</div>
                    </template>
                </van-card>
            </div>

            <!--显示商品价格-->
            <div class="goods-statistical-item" v-if="order.calcAmount">
                <span class="goods-statistical-item-left">{{langText.GoodsTogether}}</span>
                <span class="goods-statistical-item-right" style="color: red">￥{{order.calcAmount.totalAmount}}</span>
            </div>

            <!--如果有积分 则显示-->
            <div class="goods-statistical-item" v-if="order.memberIntegration > 0" style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;">
                <span class="goods-statistical-item-left">使用积分</span>
                <span class="goods-statistical-item-right">{{calculationIntegral(order.calcAmount.totalAmount)}}</span>
            </div>
        </div>

        <br/>
        <div class="goods-statistical" v-if="order.calcAmount" style="width: 95%; margin: auto; ">
            <div class="goods-statistical-item" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
                <span class="goods-statistical-item-left">{{langText.PromotionOptimizationAmount}}</span>
                <span class="goods-statistical-item-right">￥{{order.calcAmount.promotionAmount}}</span>
            </div>
            <div class="goods-statistical-item">
                <span class="goods-statistical-item-left">{{langText.freight}}</span>
                <span class="goods-statistical-item-right">￥{{order.calcAmount.freightAmount}}</span>
            </div>
            <div class="goods-statistical-item">
                <span class="goods-statistical-item-left">剩余积分</span>
                <span class="goods-statistical-item-right">{{order.memberIntegration}}</span>
            </div>
            <div class="goods-statistical-item" style="border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;" @click="showPopup">
                <span class="goods-statistical-item-left">{{langText.ChoosePaymentMethod}}</span>
                <br/>
                <van-divider />
                <span class="goods-statistical-item-right">{{payTypeText[payType]}}</span>
            </div>

            <van-popup
                    v-model="show"
                    closeable
                    round
                    position="bottom"
                    :style="{ height: '30%' }">
                <br/>
                <br/>
                <div class="goods-statistical" v-if="order.calcAmount">
                    <van-divider />
                    <div class="goods-statistical-item" style="margin: auto" >
                        <span class="goods-statistical-item-left" @click="WeChat">{{langText.WeChatPay}}</span>
                    </div>
                    <van-divider />
                    <!--如果是微信浏览器则不显示-->
                    <div class="goods-statistical-item" v-if="isWeiXin()!=4">
                        <span class="goods-statistical-item-left" @click="Alipay">{{langText.Alipay}}</span>
                    </div>
                    <van-divider />
                </div>

            </van-popup>
        </div>
        <van-submit-bar :price="calculationIntegralPayAmount(order.calcAmount.payAmount * 100)" :button-text="langText.SubmitOrders" @submit="onSubmit"
                         v-if="order.calcAmount"/>
    </div>
</template>


<script>
    import NavBar from "@/components/common/navbar/NavBar";
    import {Icon, Card, SubmitBar, Popup, Col, Row, Divider, Toast} from 'vant';
    import {getUserAddressList} from "@/network/mine/mine";
    import {subOrderOnCart, submitPayment, integralPay} from "@/network/order/order";
    import { langPackage } from "@/config/lang/goodsOrderLang";
    import { selectLang } from "@/config/setLanguage"
    import {onBridgeReady} from "../../config/wxConfig"

    export default {
        name: "GoodsOrder",
        components: {
            NavBar: NavBar,
            [Icon.name]: Icon,
            [Card.name]: Card,
            [SubmitBar.name]: SubmitBar,
            [Popup.name]: Popup,
            [Col.name]: Col,
            [Row.name]: Row,
            [Divider.name]: Divider,
            [Toast.name]: Toast,
        },
        data() {
            return {
                order: [],
                address: [],
                selectedId: this.$route.query.selectId,
                payType: 2,
                show: false,
                useIntegration: 0,
                payTypeText:{
                    1:"支付宝支付",
                    2:"微信支付"
                },
                frompay:{
                    password : "",
                    orderSn: "",
                    amount: "",
                    payType: "",
                    productName: "",
                    isWechatBrowser: 2
                },
              lang:"cn",
              langText:{}
            }
        },
        methods: {
            //计算显示价格
            calculationIntegralPayAmount(payAmount){
                //payAmount 显示500
                //如果扣除积分刚好可以等于或者大于0 则直接显示0
                if ((this.order.memberIntegration - payAmount) >= 0) {
                    //代表1分
                    return 0;
                }else {
                    //如果积分不足以扣除当前商品的价格 则从商品里扣除积分
                    let res = payAmount - this.order.memberIntegration
                    return res;
                }
            },
            //计算积分 并且设置上传的积分
            calculationIntegral(totalAmount){
                //判断 是否能够使用积分 扣款
                // console.log(this.order.memberIntegration);
                if (this.order.memberIntegration - totalAmount*100 > 0){
                    this.useIntegration = totalAmount*100;
                    return totalAmount*100;
                }else {
                    this.useIntegration = this.order.memberIntegration;
                    return this.useIntegration;
                }
            },
            initVar() {
                //获取订单信息
                this.order = this.$store.getters.goodsOrder;
                if (this.order.length == 0){
                    Toast.loading("订单加载失败！ 正在跳转");
                    setTimeout(() => {
                        this.$router.push({path: '/order/personalOrders'})
                    },1000)
                }
                //获取用户收货地址 （默认）
                getUserAddressList().then(res => {
                    let selectedStatus = 0
                    // console.log(res.data);
                    for(let item of res.data){
                        if(this.selectedId == item.id){
                            this.address = item
                            selectedStatus = 1
                        } else if(item.defaultStatus == 1 && selectedStatus == 0){
                            this.address = item
                        }
                    }
                    if(this.address.length == 0){
                        this.address = res.data[0]
                    }
                })//end

            },
            showPopup(){
                this.payType = 2;
                this.show = true;
            },
            Alipay(){
                this.payType = 1;
                this.show = false;
            },
            WeChat(){
                this.payType = 2;
                this.show = false;
            },
            goBack() {
                this.$router.back(-1)
            },
            goAddressEdit() {
                this.$router.push({path: '/mine/addressList', query: {lastSource: 'noSubmitOrder'}})
            },
            addressEdit() {
                this.$router.push({path:"/mine/addressEdit", query: {lastSource: 'noSubmitOrder'}})
            },
            onSubmit() {
                //通过购物车生成的订单
                //弹窗显示
                Toast.loading({
                    duration: 0,
                    message: '加载中...',
                    forbidClick: true,
                });
                //延迟提交
                setTimeout(() => {
                    Toast.clear();
                    if (this.address == null){
                        Toast('请添加地址收货地址！！');
                        return false;
                    }
                    //判断购物车长度大于0 则上传订单
                    if(this.$store.getters.cartIds.length > 0){
                        subOrderOnCart({
                            //选中的购物车商品ID
                            cartIds : this.$store.getters.cartIds,
                            //收货地址
                            memberReceiveAddressId: this.address.id,
                            //支付方式
                            payType: this.payType,
                            useIntegration: this.useIntegration
                        }).then(res => {
                            if (res.code == 200){
                                Toast.loading("正在支付请稍后");
                                this.frompay.paySn = res.data.order.paySn;
                                this.frompay.payAmount = res.data.order.payAmount;
                                this.frompay.productName = res.data.order.paySn;
                                this.frompay.payType = res.data.order.payType;
                                //添加使用的积分
                                this.frompay.useIntegration = this.useIntegration;
                                //订单提交完成直接支付 并且判断金额要大于0
                                if (this.frompay.payAmount > 0){
                                    //判断是否是微信浏览器
                                    if (this.isWeiXin()==4){
                                        this.frompay.isWechatBrowser = 4;
                                    }
                                    setTimeout(() => {
                                        Toast.clear()
                                        //发起支付请求
                                        submitPayment(this.frompay).then(resp => {
                                            if (resp.code == 200){
                                                if (this.frompay.payType == 1){
                                                    // 添加之前先删除一下，如果单页面，页面不刷新，添加进去的内容会一直保留在页面中，二次调用form表单会出错
                                                    let divForm = document.getElementsByTagName('divform')
                                                    if (divForm.length) {
                                                        document.body.removeChild(divForm[0])
                                                    }
                                                    const div = document.createElement('divform');
                                                    div.innerHTML = resp.data.from; // data就是接口返回的form 表单字符串
                                                    document.body.appendChild(div);
                                                    document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
                                                    document.forms[0].submit();
                                                    // var as = $(resp.data).find('.weui-form-preview__ft>.weui-form-preview__btn');
                                                    // var url = as.attr("href");
                                                    // window.location.href = resp.data;
                                                }else if(this.frompay.payType == 2){ //微信支付
                                                    //调用微信 jsapi支付
                                                    if (this.frompay.isWechatBrowser==4){
                                                        //调用微信jsapi支付(只限制于微信浏览器)
                                                        if (typeof WeixinJSBridge == "undefined") {
                                                            if (document.addEventListener) {
                                                                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                                                            } else if (document.attachEvent) {
                                                                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                                                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                                                            }
                                                        } else {
                                                            onBridgeReady(resp.data);
                                                        }
                                                    }else {
                                                        window.location.href =  resp.data.url;
                                                    }
                                                }
                                            }//if end
                                        })// SubmitPaymentend
                                    }, 1000);

                                }

                                //金额等于0的情况下 使用积分支付
                                if (this.frompay.payAmount == 0){
                                    setTimeout(() => {
                                        integralPay(this.frompay).then(res => {
                                            if (res.code == 200 ){
                                                Toast.success("支付成功！");
                                                this.$router.push({path: '/order/personalOrders'})
                                            }
                                        })

                                    }, 1000);
                                }

                            }

                            // this.$router.push({path:'/order/waitingPayment', query:{
                            //         id: res.data.order.orderSn,
                            //         static:this.payType
                            //     }})


                        })
                    }else {    //通过立即购买生成的订单
                        // console.log(this.order)
                        Toast('未选择商品')
                        // generateOrderOnBuy({
                        //     price: this.order.calcAmount.payAmount,
                        //     productAttr: this.order.cartPromotionItemList[0].productAttr,
                        //     productBrand: this.order.cartPromotionItemList[0].productBrand,
                        //     productCategoryId: this.order.cartPromotionItemList[0].productCategoryId,
                        //     productId: this.order.cartPromotionItemList[0].productId,
                        //     productName: this.order.cartPromotionItemList[0].productName,
                        //     productPic: this.order.cartPromotionItemList[0].productPic,
                        //     productSkuCode: this.order.cartPromotionItemList[0].productSkuCode,
                        //     productSkuId: this.order.cartPromotionItemList[0].productSkuId,
                        //     productSn: this.order.cartPromotionItemList[0].productSn,
                        //     productSubTitle: this.order.cartPromotionItemList[0].productSubTitle,
                        //     quantity: this.order.cartPromotionItemList[0].quantity
                        // }).then(res => {
                        //     console.log(res)
                        // this.$router.push('/order/waitingPayment')
                        // })
                    }

                }, 1000)


            },
            //判断是否是微信登录
            isWeiXin() {
                //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
                var ua = window.navigator.userAgent.toLowerCase();
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                    return 4;
                } else{
                    return 2;
                }
            },
            getProductDesc(productArr) {
                if (!productArr) {
                    return '';
                }
                let arr = JSON.parse(productArr);
                let str = '';
                for (let $i = 0; $i < arr.length; $i++) {
                    str += arr[$i]['key'] + ':' + arr[$i]['value']
                    if ($i != arr.length - 1) {
                        str += ' / ';
                    }
                }
                return str;
            },
        },

        created() {
            this.initVar();
            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
            });
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

    #goodsOrder{
        background: #f9f9f7;
    }

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);
        background-color: #ffffff;
    }

    .address-show {
        background-color: #ffffff;
    }

    .address-show-left {
        margin-top: 18px;
        float: left;
        width: 80%;
    }

    .address-show-left p {
        margin-left: 30px;
    }

    .address-show-right {
        float: left;
        height: 92px;
        width: 20%;
    }

    .goods-order-info-list {
        width: 95%;
        margin: auto;
        margin-top: 20px;
        border-radius: 5px;
    }

    .goods-order-info-name {
        background-color: #fff;
        height: 52px;
        line-height: 52px;
        border-top-radius: 10px;
    }

    ::v-deep .van-card {
        margin-top: 1px;
    }

    .goods-statistical {
        margin-top: 15px;
    }

    .goods-statistical-item {
        height: 49px;
        background-color: #fff;
        margin-top: 1px;
        display: flex;
    }

    .goods-statistical-item-left {
        margin-left: 10px;
        line-height: 49px;
        font-size: 16px;
        flex: 1;
    }

    .goods-statistical-item-centre {
        margin: 0;
        line-height: 49px;
        font-size: 16px;
        flex: 1;
    }

    .goods-statistical-item-right {
        margin-right: 10px;
        line-height: 49px;
        font-size: 16px;
        color: #666666;
        flex: 1;
        text-align: end;
    }

    .activity-info {
        color: red;
    }
</style>
